<template>
    <b-container id="banner" class="section">
        <b-row align-v="center">
            <b-col cols="12" lg="12">
                <div class="subsection">
                    <Box />
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import Box from "~/components/Banner/Box";

export default {
    components: {
        Box,
    },
};
</script>
